<template>
  <div>
    <GimbalReset :config="config" />
    <IrPalette :config="config"/>
  </div>
</template>
<script>
import { ref } from 'vue';

import IrPalette from '@/partials/Video/Camera/Options/IrPalette.vue';
import GimbalReset from '@/partials/Video/Camera/Options/Gimbal/GimbalReset.vue';

export default {
  name: "Camera_Option",
  components: {
    IrPalette,
    GimbalReset,
  },
  props: {
    config: Object,
  },
  setup() {
    return {
      video : ref(null),
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>
